import React from "react";
import {
  FlatButton,
  RaisedButton,
  Table,
  TableBody,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui";
import * as RequisitionTypes from "../../../general/paper-state";
import * as TimeUtils from "../../../general/time-utils";
import PaperStateChip from "./paper-state-chip";
import TruncatedText from "../../truncated-text";
import { canPrintPaper, paperListTotal, PRINT_DISABLED_REASON } from "./paper-display";

export default class PaperTable extends React.Component {
  render() {
    return (
      <div className="ds-table-card">
        <Table selectable={false} fixedHeader={false} style={{ width: "100%" }}>
          <TableBody displayRowCheckbox={false} showRowHover={true}>
            <TableRow>
              <TableHeaderColumn style={{ width: 100 }}>Cod</TableHeaderColumn>
              <TableHeaderColumn>Compartiment</TableHeaderColumn>
              <TableHeaderColumn style={{ minWidth: 220 }}>
                Articole
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: 120 }}>
                Data crearii
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: 120 }}>Stare</TableHeaderColumn>
              <TableHeaderColumn style={{ width: 90 }}>
                Valoare
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: 210 }}>
                Actiuni
              </TableHeaderColumn>
              {this.props.canSetPaperAsPrinted && (
                <TableHeaderColumn style={{ width: 140 }}>
                  FINALIZATA?
                </TableHeaderColumn>
              )}
            </TableRow>

            {this.props.data.map((t, i) => {
              return (
                <TableRow key={t.id}>
                  <TableRowColumn style={{ width: 100, fontWeight: 600 }}>
                    {t.yearId && t.createdYear
                      ? t.yearId + " / " + t.createdYear
                      : null}
                  </TableRowColumn>
                  <TableRowColumn>{t.department.name}</TableRowColumn>
                  <TableRowColumn
                    style={{ whiteSpace: "normal", minWidth: 220 }}
                  >
                    <TruncatedText
                      text={
                        t.articles
                          ? t.articles.map(a => a.product.name).join(", ")
                          : ""
                      }
                      limit={60}
                    />
                  </TableRowColumn>
                  <TableRowColumn style={{ width: 120 }}>
                    {TimeUtils.getSimpleFormat(t.createdDate)}
                  </TableRowColumn>
                  <TableRowColumn style={{ width: 120 }}>
                    <PaperStateChip state={t.state} />
                  </TableRowColumn>

                  <TableRowColumn style={{ width: 90 }}>
                    {paperListTotal(t, this.props.companyId)}
                  </TableRowColumn>

                  <TableRowColumn style={{ width: 210 }}>
                    {RequisitionTypes.isDraft(t.state) ? (
                      <span>
                        <RaisedButton
                          primary
                          label={"Edit"}
                          onClick={() => this.props.onEditClicked(t)}
                        />
                        <RaisedButton
                          style={{ marginLeft: "10px" }}
                          secondary
                          label={"Delete"}
                          onClick={() => this.props.onDeleteClicked(t)}
                        />
                      </span>
                    ) : (
                      <FlatButton
                        primary
                        label={"Detalii"}
                        onClick={() => this.props.onEditClicked(t)}
                      />
                    )}
                    <button
                      className="ds-link-btn"
                      disabled={!canPrintPaper(t, this.props.companyId)}
                      title={canPrintPaper(t, this.props.companyId) ? undefined : PRINT_DISABLED_REASON}
                      onClick={() => this.props.onClickPrint(t)}
                    >
                      PRINT
                    </button>
                  </TableRowColumn>

                  {this.props.canSetPaperAsPrinted && (
                    <TableRowColumn style={{ width: 140 }}>
                      <span>{t.isPrinted}</span>
                      {t.printed ? (
                        <span className="ds-chip ds-chip--approved">
                          FINALIZATA
                        </span>
                      ) : RequisitionTypes.isApproved(t.state) ? (
                        <RaisedButton
                          secondary
                          label={"FINALIZEAZA"}
                          onClick={() => this.props.onSetPaperAsPrinted(t)}
                        />
                      ) : (
                        <span></span>
                      )}
                    </TableRowColumn>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}
